import styled from 'styled-components';

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 736px) {
    display: block;
  }
  @media screen and (max-width: 490px) {
    display: flex;
    flex-direction: column;
  }
`;
export const TitleBar = styled.div`
  background-color: #fafafa;
  padding: 15px 20px;
  font-size: 15px;
  font-weight: bold;
  align-items: center;
  justify-content: space-between;
  display: flex;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  height: ${props => props.theme.height};
  div:last-child {
    border-left: 1px solid #dddddd;
  }
`;
export const Box = styled.div`
  width: ${props => props.theme.width};
  height: ${props => props.theme.height};
  color: ${props => props.theme.color};

  background-color: white;
  border-top: 1px solid #dddddd;
  flex: ${props => props.theme.flex};
  cursor: pointer;
  &:hover {
    background-color: #ededed;
  }
`;
export const Current = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #dddddd;
  border-radius: 4px;
  overflow: hidden;
`;
export const ToggleSection = styled.div`
  display: flex;
  flex-direction: column;
  transition: 0.4s max-width;
  overflow: hidden;
  max-width: ${props => (props.theme.display === 'none' || props.theme.month !== 'ThisMonth' ? '0px' : '200px')};
  @media screen and (max-width: 736px) {
    transition: 0.4s max-height;
    max-width: none;
    max-height: ${props => (props.theme.display === 'none' || props.theme.month !== 'ThisMonth' ? '0px' : '450px')};
  }
`;
export const Toggle = styled.div`
  display: flex;
  visibility: ${props => (props.theme.month !== 'ThisMonth' ? 'hidden' : 'visible')};
  justify-content: end;
  transition: 0.4s max-height;
  max-height: ${props => (props.theme.month !== 'ThisMonth' ? '0px' : '100px')};
`;
export const ToggleButton = styled.label`
  cursor: pointer;
  display: block;

  color: #337ab7;
  margin-top: 10px;
  font-size: 13px;
  text-align: right;
  text-decoration: underline;
  &:hover {
    color: #333;
  }
`;
export const Button = styled.button`
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  padding: 3px;
  border: none;
  cursor: pointer;
  background-color: #e7e6e6;

  &.previous {
    transform: rotate(90deg);
  }
  &.next {
    transform: rotate(-90deg);
  }

  &:hover {
    background-color: #d9d9d9;
  }
  &:disabled {
    opacity: 0.3;
    cursor: initial;
  }
  &:active {
    box-shadow: inset 400px 50px 0 0 #c7c4c4;
  }
`;
export const Month = styled.label`
  font-size: 14px;
  color: #3498db;
`;
export const Link = styled.a`
  text-decoration: none;
  color: #333;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  @media screen and (max-width: 736px) {
    display: flex;
    flex-direction: column;
    position: relative;
  }
`;
export const CollapseWrap = styled.div`
  position: absolute;
  left: 100%;

  div > div {
    border-right: 1px solid #ddd;
  }
  div > div:first-child {
    border-radius: 4px 4px 0px 0px;
  }
  div > div:last-child {
    border-bottom: 1px solid #ddd;
    border-radius: 0px 0px 4px 4px;
  }

  @media screen and (max-width: 736px) {
    position: relative;
    left: 0;
    border-left: 1px solid #ddd;
    border-radius: 4px 0px 0px 4px;
    div > div:first-child {
      border-top: none;
    }
  }
`;
